import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import tools from '../../utils/tools';
import { Sidebar } from '../Layout/Sidebar';

const CategoryManage = () => {
  const [item, setItem] = useState<any>();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const dispatch = useDispatch();
  const { id: paramId } = useParams();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [image, setImage] = useState<any>({});
  const [parentId, setParentId] = useState('');

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.category.basic + (paramId || ''), true).post({
      title: title,
      description: description,
      parentId: parentId,
    });
    if (image.data) {
      const formData = new FormData();

      formData.append('file', image.data);

      const mediaRes = await restApi(endpoints.category.media + res.data.id, true).upload(formData);
    }

    if (res.code == 200) {
      Swal.fire({
        title: 'موفق',
        text: `دسته بندی با موفقیت ${paramId ? 'ویرایش' : 'ساخته'} شد`,
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          navigate('/category')
        }
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }

    dispatch(setLoading(false));
  };

  const fetchItem = async () => {
    dispatch(setLoading(true));

    if (paramId) {
      const res = await restApi(endpoints.category.single + paramId, true).get();

      if (res.code == 200) {
        setTitle(res.data?.title)
        setDescription(res.data?.description)
        setParentId(res.data?.parentId)
        setImage({
          data: undefined,
          preview: res.data.media?.url
        });
      }
    }

    const result = await restApi(endpoints.category.index, true).get({ type: 'children'});

    const sortedData = [];

    result.data.map(e => tools.extractChildren(e, sortedData));

    if (result.code == 200) {
      setCategories(sortedData);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchItem();
  }, []);

  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
           ارسال
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه دسته بندی ها</h1>
             <h1 className="dashBoardTitle">${paramId ? 'ویرایش' : 'ساخته'} دسته بندی  </h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate('/category/')}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">اطلاعات دسته بندی</h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setTitle(input.target.value)} value={title}/>
            <label className="sideBarTitle">والد</label>
            <Select options={tools.selectFormatter(categories, 'id', 'title', 'بدون والد')} value={{ value: parentId, label: categories.find(e => e.id == parentId)?.title }} className="width100" id="infoTitle" onChange={(selected: any) => setParentId(selected.value)}/>
            <label className="sideBarTitle" htmlFor="infoAmount">توضیحات</label>
            <textarea className="addInput" placeholder="توضیحات" id="infoAmount" onChange={(input: any) => setDescription(input.target.value)} value={description}/>
            <div className="AddInfoContainer">
              <input type="file" onChange={(input) => setImage({
                data: input.target.files[0],
                preview: URL.createObjectURL(input.target.files[0]),
              })}/>
              <img src={image.preview} alt='عکس' className="bannerImage"/>
            </div>
          </form>
        </section>
      </main>
      </body>
    </>
  );
};
export default CategoryManage;